module.exports = __webpack_public_path__ + "static/media/3.ec5844d8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/brest/3.JPG
// module id = 217
// module chunks = 0